// OPEN ALL EXTERNAL LINKS IN NEW TAB
function targetBlank() {
    var internal = location.host.replace("www.", "");
    internal = new RegExp(internal, "i");
    var a = document.getElementsByTagName('a'); // grab every link on the page
    for (var i = 0; i < a.length; i++) {
        var href = a[i].host; // set the host of shopify link
        if( !internal.test(href) ) { // make sure the href of a element in loop doesn't contain current site's host
            a[i].setAttribute('target', '_blank'); // if it doesn't, set attribute
        }
    }
};
// Run the function targetBlank()
targetBlank();

/* Make footer newsletter header not clickable/collapsible */
document.addEventListener('DOMContentLoaded', function () {
  const newsletter = document.querySelector(".site-footer__block--newsletter");
  const summary = newsletter.querySelector('summary');
  const details = newsletter.querySelector('details');
  if (summary && details) {
    console.log("got sum and deets");
    summary.addEventListener('click', function (event) {
      event.preventDefault();
      details.setAttribute('open', ''); // ensure it stays open
    });
  }
});